import React from "react";
import { Modal } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import "./account-modals.css";

interface AccountModalShellProps {
  open: boolean;
  onClose: () => void;
  icon: React.ReactNode;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  width?: number;
  closable?: boolean;
}

/**
 * Chrome corporativo compartido para los modales de cuenta (avatar / clave):
 * header con degradado de la marca, ícono, título/subtítulo y botón de cerrar.
 */
export const AccountModalShell = ({
  open,
  onClose,
  icon,
  title,
  subtitle,
  children,
  footer,
  width = 460,
  closable = true,
}: AccountModalShellProps) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      maskClosable={closable}
      keyboard={closable}
      centered
      width={width}
      className="acct-modal"
      destroyOnClose
    >
      <div className="acct-modal-header">
        <div className="acct-modal-header__icon">{icon}</div>
        <div className="acct-modal-header__text">
          <span className="acct-modal-header__title">{title}</span>
          {subtitle && (
            <span className="acct-modal-header__subtitle">{subtitle}</span>
          )}
        </div>
        {closable && (
          <button
            type="button"
            className="acct-modal-header__close"
            onClick={onClose}
            aria-label="Cerrar"
          >
            <CloseOutlined />
          </button>
        )}
      </div>

      <div className="acct-modal-body">{children}</div>

      {footer && <div className="acct-modal-footer">{footer}</div>}
    </Modal>
  );
};
